import React from 'react'

import Typography from 'components/atoms/Typography'
import StartTestLink from 'components/pages/AptitudeLanding/StartTestLink'

const AptitudeStickyContent = () => (
  <div className="aptitude-sticky-content">
    <Typography component="p" variant="subheading" className="aptitude-sticky-content__text">
      Tes Minat Bakat Quipper Campus
    </Typography>
    <StartTestLink/>
    <style jsx>
      {`
        .aptitude-sticky-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          :global(&__text) {
            font-weight: bold;
            display: none;
            @media screen and (min-width: 768px) {
              display: unset;
            }
          }
        }
      `}
    </style>
  </div>
)

export default AptitudeStickyContent
